import OneRow from "./OneRow";

export default OneRow;
